import type {
  Integration,
  IntegrationCardData,
  IntegrationModule,
  IntegrationModuleCardData,
} from "../types";

// Transform integration data for card display
// Returns the description key or fallback - translation happens in the component
export function transformToCardData(
  integration: Integration,
): IntegrationCardData {
  return {
    id: integration.id,
    name: integration.name, // Stable identifier for routes
    displayName: integration.displayName, // Translation key for display
    // Return the description key as-is; translation will be handled by the component
    description: integration.description || "integrations.descriptions.default",
    isActive: integration.isActive,
    configurationSchemaJson: integration.configurationSchemaJson,
    modules: integration.modules,
  };
}

// Transform integration module data for card display
export function transformModuleToCardData(
  module: IntegrationModule,
): IntegrationModuleCardData {
  return {
    id: module.id,
    moduleName: module.moduleName,
    moduleDisplayName: module.moduleDisplayName,
    // Return the description key as-is; translation will be handled by the component
    moduleDescription:
      module.moduleDescription || "integrations.modules.descriptions.default",
    isActive: module.isActive,
    scopes: module.scopes || [],
  };
}
